import { Grid, Paper, TableCell, TableRow, Tooltip } from "@material-ui/core";
import { Sync } from "@material-ui/icons";
import {
  DatatablesFooterServerSide,
  IconButtonDatatable,
  Loading,
  Title,
} from "App/Component/ui";
import { getComparator, stableSort } from "App/Component/ui/datatable/utils";
import { useDatatables, useDatatablesServerSide } from "App/hooks";
import {
  defaultToastError,
  defaultToastSuccess,
  formatRupiah,
  isNull,
} from "App/utils/helpers";
import { DrawerMaster } from "components/molecules";
import { FreezeTable } from "components/organism";
import React, { useEffect, useState } from "react";

import { DISABLED_BUTTON_SUBMIT } from "App/constants";
import {
  getMonitoring,
  headCellsMonitoring,
  jalankanRekrusif,
} from "./helpers";

const SHOW_RESTART_BUTTON = {
  label: "JALANKAN ANTRIAN SINGKRONISASI",
  color: "#296218",
  state: false,
  disabled: false,
};

function ToggleDetailStatusSyncIHS({ open, toggleDrawer }) {
  const [data, setData] = useState([]);
  const [rows, setRows] = useState([]);
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);

  const [disabledRestart, setDisabledRestart] = useState(SHOW_RESTART_BUTTON);

  useEffect(() => {
    (async () => {
      await fetchData();
    })();
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchData = async (pages = 1, limit = 10) => {
    setLoading(true);
    const res = await getMonitoring(pages, limit);
    if (res.state) {
      setRows(res.data);
      setData(res.proses);
      setTotalData(res.meta.count);
      setLoading(false);
    } else {
      setRows([]);
      setData(0);
      setLoading(false);
      defaultToastError(res.message);
    }
  };

  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "",
    orderByRow: [],
  });

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
    resetPagination,
  } = useDatatablesServerSide({ setNewData: fetchData });

  const jalanRekonsilRekrusif = async () => {
    setLoading(true);
    setDisabledRestart(DISABLED_BUTTON_SUBMIT);
    const res = await jalankanRekrusif();
    if (res.state) {
      defaultToastSuccess(res.message);
      resetPagination();
      fetchData();
    } else {
      defaultToastError(res.message);
      setLoading(false);
    }
    setDisabledRestart(SHOW_RESTART_BUTTON);
  };

  return (
    <>
      <DrawerMaster open={open} toggleDrawer={toggleDrawer} widthList={900}>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
        >
          <Title title="Monitoring Singkronisasi Satu Sehat Berjalan" />
        </Grid>
        <div className="p-1">
          <Grid container spacing={1}>
            <Grid item md={6}>
              <Paper className="p-1">
                <p
                  style={{
                    textAlign: "center",
                    fontSize: "1vw",
                    fontWeight: 800,
                  }}
                >
                  SEDANG PROSES
                </p>
                <p style={{ textAlign: "center", fontSize: "3vw" }}>
                  {formatRupiah(data?.length ?? 0)}
                </p>
              </Paper>
            </Grid>

            <Grid item md={6}>
              <Paper className="p-1">
                <p
                  style={{
                    textAlign: "center",
                    fontSize: "1vw",
                    fontWeight: 800,
                  }}
                >
                  TOTAL ANTRIAN
                </p>
                <p style={{ textAlign: "center", fontSize: "3vw" }}>
                  {formatRupiah(totalData ?? 0)}
                </p>
              </Paper>
            </Grid>

            <Grid item md={12}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "7px",
                  width: "100%",
                }}
              >
                <button
                  type="button"
                  disabled={disabledRestart.state}
                  onClick={() =>
                    data.length > 0 ? null : jalanRekonsilRekrusif()
                  }
                  style={{
                    background:
                      data.length > 0 ? "#D8D8D8" : disabledRestart.color,
                    display: "block",
                    width: "100%",
                    color: "white",
                    border: 0,
                    borderRadius: "4px",
                    fontWeight: "600",
                    padding: "0.6rem 2rem",
                    fontSize: "15px",
                    marginTop: "25px",
                    marginBottom: "25px",
                  }}
                  className={`button-login`}
                >
                  {disabledRestart.label}
                </button>

                <IconButtonDatatable
                  style={{
                    backgroundColor: "#296218",
                    padding: "1.3rem 2rem",
                  }}
                  onClick={() => {
                    resetPagination();
                    fetchData();
                  }}
                >
                  <Tooltip title={"Perbarui Data"} aria-label="update">
                    <Sync fontSize={"large"} style={{ color: "#fff" }} />
                  </Tooltip>
                </IconButtonDatatable>
              </div>
            </Grid>

            <Grid item md={12} style={{ marginBottom: "1.5rem" }}>
              <Loading show={loading} />
              <FreezeTable
                headCells={headCellsMonitoring}
                handleRequestSort={handleRequestSort}
                order={order}
                length={length}
                orderBy={orderBy}
              >
                {stableSort(rows, getComparator(order, orderBy)).map(
                  (row, index) => {
                    return (
                      <TableRow hover key={index}>
                        <TableCell align="center">{index + 1}</TableCell>
                        <TableCell align="left">
                          {isNull(row?.id) ? "-" : row?.id}
                        </TableCell>
                        <TableCell align="left">
                          {isNull(row?.fullname) ? "-" : row?.fullname}
                        </TableCell>
                        <TableCell align="left">
                          {isNull(row?.nik) ? "-" : row?.nik}
                        </TableCell>
                        <TableCell align="left">
                          {isNull(row?.id_ihs) ? "-" : row?.id_ihs}
                        </TableCell>
                      </TableRow>
                    );
                  }
                )}
              </FreezeTable>
              <DatatablesFooterServerSide
                totalData={totalData}
                pagination={pagination}
                handleChangeLimit={handleChangeLimit}
                onPrevious={onPrevious}
                onNext={onNext}
                currentPage={pagination.page}
                handleClickPageNumber={handleClickPageNumber}
              />
            </Grid>
          </Grid>
        </div>
      </DrawerMaster>
    </>
  );
}

export default ToggleDetailStatusSyncIHS;
